'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const BaseView = require('components-framework/view/base.view');
const flightDetailsCollection = require('od-modules/collections/flight_details.collection').getInstance();
const DelayCompensationTrackingGuarantees = require('od-modules/../tracking/ancillaries_tracking/ancillaries_guarantees');
const DELAY = 'DELAY';
const priceB = 14.99;
const priceC = 5.99;
const delayReturnPriceB = '€100';
const delayReturnPriceC = '€200';

module.exports = createWidgetFactory({
    el: $('.delay_compensation'),
    name: 'delay_compensation',
    modelClass: Backbone.Model.extend({
        shown: false,
    }),
    viewClass: BaseView.extend({
        selectors: {
            showConfirmationNag: '.delay_compensation_add_button',
            showDetailsNag: '.delay_compensation_details_link',
            confirmationNag: '.delay_compensation_nag_confirmation',
            detailsNag: '.delay_compensation_nag_details',
            confirmationNagButton: '.delay_compensation_confirmation_button',
            detailsNagButton: '.delay_compensation_details_button',
            modalCloseCross: '.modal_close',
        },
        confirmationNag: {
            toggle: () => {},
        },

        detailsNag: {
            toggle: () => {},
        },

        delayCompensationTracking: () => {},

        initialize() {
            flightDetailsCollection.getLoadedPromise().then(() => {
                this.render();
                this.createDelayCompensationConfirmationNag();
                this.createDelayCompensationDetailsNag();
                this.bindButtons();
                this.initDelayCompensationTracking();
            });
        },

        bindButtons() {
            this.$el.find(this.selectors.showConfirmationNag).on(Odigeo.Events.tap, this.showConfirmationNag.bind(this));
            this.$el.find(this.selectors.confirmationNagButton).on(Odigeo.Events.tap, this.hideConfirmationNag.bind(this));
            this.$el.find(this.selectors.showDetailsNag).on(Odigeo.Events.tap, this.showDetailsNag.bind(this));
            this.$el.find(this.selectors.detailsNagButton).on(Odigeo.Events.tap, this.showConfirmationNagFromDetails.bind(this));
            this.$el.find(this.selectors.modalCloseCross).on(Odigeo.Events.tap, this.hideDetailsNag.bind(this));
        },

        onChange() {
            this.render();
        },

        render() {
            this.$el.html(this.templates.default(this.getViewData()));
        },

        getViewData() {
            return {
                templates: this.templates,
                keys: this.keys,
                shown: this.model.get('shown'),
                pricePerSegment: this.getPricesBySegments(),
                getSubtitleText: this.getSubtitleText(),
            };
        },

        createDelayCompensationConfirmationNag() {
            this.confirmationNag = new Odigeo.UIElements.Lightbox(this.$el.find(this.selectors.confirmationNag), {
                overFullPage: false,
                closeOnOuterClick: false,
            });
        },

        createDelayCompensationDetailsNag() {
            this.detailsNag = new Odigeo.UIElements.Lightbox(this.$el.find(this.selectors.detailsNag), {
                overFullPage: false,
                closeOnOuterClick: false,
            });
        },

        showConfirmationNag() {
            this.confirmationNag.toggle(true);
            this.detailsNag.toggle(false);
            this.delayCompensationTracking.trackEvent('add', DELAY);
            this.delayCompensationTracking.trackEvent('nag.delay.appears', DELAY);
        },

        showConfirmationNagFromDetails() {
            this.confirmationNag.toggle(true);
            this.detailsNag.toggle(false);
            this.delayCompensationTracking.trackEvent('add', DELAY);
            this.delayCompensationTracking.trackEvent('add_from_details', DELAY);
            this.delayCompensationTracking.trackEvent('nag.delay.appears', DELAY);
        },

        hideConfirmationNag() {
            this.confirmationNag.toggle(false);
            this.detailsNag.toggle(false);
            this.delayCompensationTracking.trackEvent('nag.delay.accept', DELAY);
            this.onCloseNag();
        },

        hideDetailsNag() {
            this.detailsNag.toggle(false);
            this.delayCompensationTracking.trackEvent('close_details', DELAY);
        },

        showDetailsNag() {
            this.detailsNag.toggle(true);
            this.delayCompensationTracking.trackEvent('open_details', DELAY);
        },

        onCloseNag() {
            this.model.set('shown', true);
            this.render();
        },

        getPricesBySegments() {
            return Odigeo.Utils.formatCurrency((this.isBPartition() ? priceB : priceC) / flightDetailsCollection.getSegments().length);
        },

        isBPartition() {
            return Odigeo.AB.getDelayCompensation === 2;
        },

        getSubtitleText() {
            const subtitleB = Odigeo.Utils.replaceCmsKeyArgs(this.keys.subtitleb, delayReturnPriceB);
            const subtitleC = Odigeo.Utils.replaceCmsKeyArgs(this.keys.subtitlec, delayReturnPriceC);
            return this.isBPartition() ? subtitleB : subtitleC;
        },

        initDelayCompensationTracking() {
            this.delayCompensationTracking = () => {};
            this.delayCompensationTracking = new DelayCompensationTrackingGuarantees();
        },
    }),
    methods: {

    },
    isEnabled() {
        return Odigeo.AB.getDelayCompensation > 1;
    },
});
